import { Compass, HandHeart, Map, Users2, ShieldCheck } from "lucide-react";
import Reveal from "../../../src/components/Reveal";

const ITEMS = [
  {
    icon: Compass,
    title: "Enfoque estratégico, no solo legal",
    text: "Pensamos como aliados de negocio: cada solución busca proteger valor y habilitar decisiones.",
  },
  {
    icon: HandHeart,
    title: "Acompañamiento personalizado",
    text: "Asesores designados según especialidad, con seguimiento real y conceptos jurídicos por escrito.",
  },
  {
    icon: Map,
    title: "Cobertura nacional",
    text: "Sede en Cartagena con presencia operativa en todo el territorio colombiano.",
  },
  {
    icon: Users2,
    title: "Equipo multidisciplinario",
    text: "Abogados y contadores trabajando juntos para una respuesta técnica integral.",
  },
  {
    icon: ShieldCheck,
    title: "Soluciones preventivas y correctivas",
    text: "Identificamos riesgos antes de que escalen y resolvemos los que ya existen.",
  },
];

export default function Differentiators() {
  return (
    <section data-testid="home-differentiators" className="bg-white section-pad">
      <div className="container-x">
        <Reveal className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="gold-rule" />
            <span className="overline">Por qué elegirnos</span>
          </div>
          <h2 className="font-serif text-navy-900 text-3xl md:text-4xl lg:text-5xl leading-tight">
            Diferenciales que <em className="italic" style={{ color: "#C5A059" }}>respaldan</em> nuestro trabajo.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal key={it.title} delay={i * 80}>
                <div className="border-l-2 pl-6" style={{ borderColor: "#C5A059" }}>
                  <Icon size={28} strokeWidth={1.4} style={{ color: "#0A192F" }} />
                  <h3 className="mt-5 font-serif text-xl text-navy-900 leading-snug">
                    {it.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">
                    {it.text}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}